"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemEvent = void 0;
var tslib_1 = require("tslib");
var BusinessProcessEvent_1 = require("./BusinessProcessEvent");
var Enum_1 = require("../utils/Enum");
var SystemEvent = /** @class */ (function (_super) {
    tslib_1.__extends(SystemEvent, _super);
    function SystemEvent(businessProcessName, componentType, systemMessage) {
        var _this = _super.call(this, businessProcessName, componentType, null, null) || this;
        _this.systemMessage = systemMessage;
        _this.EventType = Enum_1.ItEventType.SystemEvent;
        return _this;
    }
    Object.defineProperty(SystemEvent.prototype, "SystemMessage", {
        get: function () {
            return this.systemMessage;
        },
        set: function (value) {
            this.systemMessage = value;
        },
        enumerable: false,
        configurable: true
    });
    SystemEvent.prototype.IsValidEvent = function (isValid) {
        if (!this.EventName || 0 === this.EventName.length) {
            return false;
        }
        else {
            return true;
        }
    };
    return SystemEvent;
}(BusinessProcessEvent_1.BusinessProcessEvent));
exports.SystemEvent = SystemEvent;
//# sourceMappingURL=SystemEvent.js.map